// extracted by mini-css-extract-plugin
export default {"page_wrap":"TeamMember_page_wrap__slzSD"};